import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

// component that displays a notification about the upcoming changes to GummySearch and links to the final chapter and purchase links
const TransitionNotification = ({
  utmSource="app-notification",
  showLink=true,
}) => {
  return (
    <div className="mb-4 p-2 rounded-lg bg-gray-700 shadow-lg">
      <div className="flex items-center justify-between flex-wrap">
        <div className="w-0 flex-1 flex items-center">
          <p className="ml-3 font-medium text-white space-x-1">
            GummySearch is closed for signups/purchase as of 11/30/2025.
            Read more about this change <a href={`https://gummysearch.com/closing-time/?utm_source=${utmSource}`} target="_blank" className="underline cursor-pointer">here</a> or find alternatives
            <a href={`https://gummysearch.com/gummysearch-alternatives/?utm_source=${utmSource}`} target="_blank" className="underline cursor-pointer">here</a>.
          </p>
        </div>
      </div>
    </div>
  )
}

export default TransitionNotification;